module.exports = __webpack_public_path__ + "img/Avatar-19.0f90c638.gif";